function truncateString(textEl) {
  import("text-clipper").then(clip => {
    window.requestIdleCallback(() => {
      let characters = parseInt(textEl.getAttribute("data-newsfeed-characters"), 10);
      let target = textEl.getAttribute("data-newsfeed-target");
      let redirectPath = textEl.getAttribute("data-newsfeed-redirect-path");
      let elId = textEl.getAttribute("data-newsfeed-el-text");
      let html = textEl.innerHTML;
      let indicator = "...";
      if (characters > 200) {
        indicator = "";
      } else {
        characters += 3;
      }
      if (target === "redirect") {
        let ellipsis = `<a href="${redirectPath}"> Read more...</a>`;
        html = clip.default(html, characters, {
          html: true,
          indicator: indicator
        });
        textEl.innerHTML = html;
      } else {
        let originalHtml = html;
        let ellipsis = `<a href="javascript:void(0)" data-el-id="${elId}"> Read more...</a>`;
        let newHtml = clip.default(html, characters, {
          html: true,
          indicator: indicator
        });
        textEl.innerHTML = `<div data-original-text="${elId}" style="display: none;">${originalHtml}</div><div data-truncate-text>${newHtml}</div>`;
        let aEls = textEl.querySelectorAll(`a[data-el-id="${elId}"]`);
        for (let i = 0, len = aEls.length; i < len; i += 1) {
          aEls[i].addEventListener("click", () => {
            textEl.querySelector("[data-truncate-text]").style.display = "none";
            textEl.querySelector("[data-original-text]").style.display = "";
          });
        }
      }
    });
  });
}
const truncateStringInContext = function (context) {
  let newsfeedTexts = context.querySelectorAll("[data-newsfeed-el-text]");
  for (let i = 0; i < newsfeedTexts.length; ++i) {
    let textEl = newsfeedTexts[i];
    truncateString(textEl);
  }
};
const initNewsfeedInContext = function (context) {
  let newsfeedTexts = context.querySelectorAll("[data-newsfeed-el-text]");
  for (let i = 0; i < newsfeedTexts.length; ++i) {
    let textEl = newsfeedTexts[i];
    truncateString(textEl);
  }
};
const init = () => {
  let newsfeedTexts = document.querySelectorAll("[data-newsfeed-el-text]");
  for (let i = 0; i < newsfeedTexts.length; ++i) {
    let textEl = newsfeedTexts[i];
    truncateString(textEl);
  }
};
export { truncateStringInContext, initNewsfeedInContext, init };